import React from "react";
import ReactDOM from "react-dom/client";  // Correct import for React 18

import AppWrapper from "./App";
import "./index.css";
import { store } from './redux/store';
import { Provider } from "react-redux"; // Import the Provider from react-redux

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}> {/* Wrap the App with the Provider */}
  <AppWrapper />
  </Provider>
);
